const ApiService = {
  headers: {'Content-Type': 'application/json'},

  async handleResponse(response) {
    const data = await response.json();
    if (!response.ok) {
      throw data;
    }
    return data;
  },

  async get(resource) {
    const response = await fetch(resource, {
      headers: this.headers
    });
    return this.handleResponse(response);
  },

  async post(resource, params = {}) {
    const response = await fetch(resource, {
      headers: this.headers,
      method: 'POST',
      body: JSON.stringify(params)
    });
    return this.handleResponse(response);
  }
};

export default ApiService;
